/* eslint no-param-reassign: 0 */
import { FC } from 'react';
import Fuse from 'fuse.js';
import { InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { NodeObject } from 'react-force-graph-2d';
import { QueryCallback, SearchInput } from '../../../../elements/SearchInput';
import { COUNT_DENDROGRAM } from '../../../../../colors';

export type FuseResult<T> = {
  item: T;
  refIndex: number;
  score?: number;
};

export interface FilterInputProps {
  data: NodeObject[];
  placeholder?: string;
  filterCallback: (result: FuseResult<NodeObject>[] | null) => void;
  onType?: QueryCallback;
  onEnterKeyDown?: () => void;
}

export const FilterInput: FC<FilterInputProps> = ({
  data,
  placeholder,
  filterCallback,
  onType,
  onEnterKeyDown,
}) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      if (onEnterKeyDown) {
        onEnterKeyDown();
      }
    }
  };

  const queryCallback: QueryCallback = (q: string) => {
    const fuse = new Fuse(data, {
      keys: ['id'],
      includeScore: true,
      useExtendedSearch: true,
    });

    filterCallback(q && q.length > 0 ? fuse.search(`'${q}`) : null);
    if (onType) {
      onType(q);
    }
  };

  return (
    <SearchInput
      name={'filter'}
      inputProps={{
        onKeyDown: handleKeyDown,
        autoFocus: true,
        sx: {
          ml: 2,
          color: COUNT_DENDROGRAM('light').SEARCH_BAR.INPUT.color,
          '&::placeholder': {
            color: COUNT_DENDROGRAM('light').SEARCH_BAR.INPUT.placeholder_color,
          },
        },
        startAdornment: (
          <InputAdornment
            position="start"
            style={{
              color: COUNT_DENDROGRAM('light').SEARCH_BAR.INPUT.icon,
            }}
          >
            <SearchIcon />
          </InputAdornment>
        ),
        placeholder: placeholder || 'Filter nodes...',
      }}
      queryCallback={queryCallback}
    />
  );
};
